/* Melinava Produktfinder, erzeugt von theme-build.py aus dem Prototyp. Nicht von Hand ändern. */
(function () {
if (!document.getElementById('mv-pf')) return;
const START = [];
function laufNachLaden(fn){ START.push(fn); }   /* erst am Ende ausführen, wenn alle Konstanten stehen */

const R = document.getElementById('mv-pf');
const CFG = JSON.parse(document.getElementById('mv-pf-config').textContent);
const KATALOG = (function () {
  /* Liquid liefert den Katalog nach Produkt-ID (Handles sind je Sprache übersetzt); hier zurück auf die deutschen Handles der Konfiguration */
  const roh = JSON.parse(document.getElementById('mv-pf-katalog').textContent);
  const k = {};
  for (const h in (CFG.ids || {})) if (roh[CFG.ids[h]]) k[h] = roh[CFG.ids[h]];
  for (const h in k) {
    k[h].preis = k[h].preis / 100;
    k[h].preis_lieferung = k[h].preis_lieferung == null ? null : k[h].preis_lieferung / 100;
    k[h].einnahme = (CFG.einnahme || {})[h] || '';
  }
  return k;
})();
const T = JSON.parse(document.getElementById('mv-pf-texte').textContent);
const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const SHOP = ROOT.replace(/\/$/, '');
const LIVE = !!(window.Shopify && Shopify.theme && Shopify.theme.role === 'main');
const t = (k, v) => String(T[k] == null ? k : T[k]).replace(/\{(\w+)\}/g, (_, n) => v && v[n] != null ? v[n] : '');
const zahl1 = n => new Intl.NumberFormat(T.locale, {minimumFractionDigits: 1, maximumFractionDigits: 1}).format(n);

const ICONS = {
  energie:'<path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z"/>',
  immun:'<path d="M12 3l8 3v6c0 5-3.5 8.2-8 9-4.5-.8-8-4-8-9V6l8-3z"/><path d="M9 12l2 2 4-4"/>',
  haut:'<path d="M12 3c.6 4.2 2.8 6.4 7 7-4.2.6-6.4 2.8-7 7-.6-4.2-2.8-6.4-7-7 4.2-.6 6.4-2.8 7-7z"/><path d="M19 16c.2 1.4.9 2.1 2 2.3-1.1.2-1.8.9-2 2.2-.2-1.3-.9-2-2-2.2 1.1-.2 1.8-.9 2-2.3z"/>',
  schlaf:'<path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z"/>',
  stress:'<path d="M5 19c0-8 6-14 15-14 0 9-6 15-14 15"/><path d="M5 19l8-8"/>',
  darm:'<path d="M7 4h7a4 4 0 0 1 0 8h-4a4 4 0 0 0 0 8h7"/>',
  gelenke:'<path d="M8.5 6.5a2.5 2.5 0 1 0-3.5 3.5l.7-.7 8.6 8.6-.7.7a2.5 2.5 0 1 0 3.5-3.5 2.5 2.5 0 1 0-3.5-3.5l-.7.7-5.7-5.7.7-.7a2.5 2.5 0 1 0-3.5-3.5z"/>',
  fokus:'<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="4.5"/><circle cx="12" cy="12" r="1"/>',
  hormone:'<circle cx="12" cy="9" r="5"/><path d="M12 14v7M9 18h6"/>',
  sport:'<path d="M6.5 8v8M3.5 10v4M17.5 8v8M20.5 10v4M6.5 12h11"/>',
  frau:'<circle cx="12" cy="9" r="5"/><path d="M12 14v7M9 18h6"/>',
  mann:'<circle cx="10" cy="14" r="5"/><path d="M14 10l6-6M15 4h5v5"/>',
  offen:'<circle cx="12" cy="12" r="8.5"/><path d="M8 12h8"/>',
  person:'<circle cx="12" cy="8" r="4"/><path d="M4.5 21c1-4 4-6 7.5-6s6.5 2 7.5 6"/>',
  schale:'<path d="M3.5 11h17a8.5 8.5 0 0 1-17 0z"/><path d="M8 7c0-1.5 1-2 1-3M12 7c0-1.5 1-2 1-3M16 7c0-1.5 1-2 1-3"/>',
  ei:'<path d="M12 3c3.5 0 6.5 5.5 6.5 10a6.5 6.5 0 0 1-13 0C5.5 8.5 8.5 3 12 3z"/>',
  blatt:'<path d="M5 19c0-8 6-14 15-14 0 9-6 15-14 15"/><path d="M5 19l8-8"/>',
  kapsel:'<g transform="rotate(-35 12 12)"><rect x="3" y="8.5" width="18" height="7" rx="3.5"/><path class="voll" d="M12 8.5H6.5a3.5 3.5 0 0 0 0 7H12z"/></g>',
  tropfen:'<path class="voll" d="M12 3s6.5 7 6.5 11.5a6.5 6.5 0 0 1-13 0C5.5 10 12 3 12 3z"/>',
  egal:'<path d="M4 12h16M14 6l6 6-6 6"/>',
  schneeflocke:'<path d="M12 2.5v19M3.8 7.2l16.4 9.6M3.8 16.8l16.4-9.6M9.5 4l2.5 2.5L14.5 4M9.5 20l2.5-2.5 2.5 2.5"/>',
  haare:'<path d="M6 21c0-7 1-12 6-16M12 21c0-6 .5-10 4-14M18 21c0-5-.5-8 1.5-11"/>',
  naegel:'<path d="M8 21V9a4 4 0 0 1 8 0v12"/><path d="M8.5 10.5h7"/>',
  flugzeug:'<path class="voll" stroke="none" d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>',
  waage:'<path d="M12 4v16M7 20h10M5 8h14M5 8l-2.5 6a2.5 2.5 0 0 0 5 0L5 8zM19 8l-2.5 6a2.5 2.5 0 0 0 5 0L19 8z"/>',
  knochen:'<path d="M8.5 6.5a2.5 2.5 0 1 0-3.5 3.5l.7-.7 8.6 8.6-.7.7a2.5 2.5 0 1 0 3.5-3.5 2.5 2.5 0 1 0-3.5-3.5l-.7.7-5.7-5.7.7-.7a2.5 2.5 0 1 0-3.5-3.5z"/>',
  herz:'<path d="M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.2a4.3 4.3 0 0 1 7.5 2.6C19.5 15.4 12 20 12 20z"/><path d="M4.5 12.5h4l1.5-2.5 2.5 5 1.5-2.5h5"/>',
  mail:'<rect x="3" y="5.5" width="18" height="13" rx="2"/><path d="M3.5 7l8.5 6.5L20.5 7"/>',
  laufen:'<circle cx="14" cy="4.5" r="2"/><path d="M8 21l3-6 3 2v4M6 12l3-4 4 1 2 3 3 1M11 15l1.5-5"/>',
  uhr:'<circle cx="12" cy="12" r="8.5"/><path d="M12 7v5l3 2"/>',
  ziel:'<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="4.5"/><circle cx="12" cy="12" r="1"/>',
  haken:'<path d="M5 12.5l4.5 4.5L19 7.5"/>',
  sonne:'<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4"/>',
  mond:'<path class="voll" d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z"/>',
  kunden:'<circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c.8-3.5 3.4-5.5 6.5-5.5s5.7 2 6.5 5.5"/><path d="M15.5 4.6a3.5 3.5 0 0 1 0 6.8M18 14.8c2 .7 3.2 2.4 3.6 5.2"/>',
  stern:'<path d="M12 3l2.8 5.8 6.2.9-4.5 4.4 1 6.2L12 17.4l-5.5 2.9 1-6.2L3 9.7l6.2-.9L12 3z"/>',
  schild:'<path d="M12 3l8 3v6c0 5-3.5 8.2-8 9-4.5-.8-8-4-8-9V6l8-3z"/><path d="M9 12l2 2 4-4"/>'
};
const svg = (n, cls='') => `<svg viewBox="0 0 24 24" class="${cls}" aria-hidden="true">${ICONS[n]||''}</svg>`;
const SHOPICONS = {
  energie:'https://melinava.de/cdn/shop/files/energie-leistung.webp?v=1765627748&width=160',
  immun:'https://melinava.de/cdn/shop/files/immunkracht-afweer.webp?v=1765663435&width=160',
  haut:'https://melinava.de/cdn/shop/files/schonheit-anti-aging.webp?v=1765627794&width=160',
  schlaf:'https://melinava.de/cdn/shop/files/entspannung-schlaf.webp?v=1765627762&width=160',
  darm:'https://melinava.de/cdn/shop/files/verdauung-gewicht.webp?v=1765627733&width=160',
  gelenke:'https://melinava.de/cdn/shop/files/knochen-beweglichkeit.webp?v=1765627775&width=160',
  fokus:'https://melinava.de/cdn/shop/files/Konzentration.webp?v=1765384550&width=160'
};
/* neu gezeichnet im Stil der Shop-Kategorie-Icons, Dateien in icons/neu/ */
const NEUICONS = {
  sport:'<g fill="#111"><rect x="3" y="18" width="5" height="12" rx="2"/><rect x="9.5" y="11" width="7" height="26" rx="2.5"/><rect x="16" y="21.5" width="16" height="5" rx="1.5"/><rect x="31.5" y="11" width="7" height="26" rx="2.5"/><rect x="40" y="18" width="5" height="12" rx="2"/></g>',
  stress:'<g fill="#111"><ellipse cx="24" cy="39" rx="17" ry="5.5"/><ellipse cx="24" cy="29.5" rx="12" ry="4.6"/><ellipse cx="24" cy="21" rx="7.5" ry="3.8"/></g><g fill="none" stroke="#fff" stroke-width="1.6"><ellipse cx="24" cy="29.5" rx="12.8" ry="5.4"/><ellipse cx="24" cy="21" rx="8.3" ry="4.6"/></g><path d="M24 16.5c0-5 3-8.5 8.5-9.5-.3 5.6-3.4 8.9-8.5 9.5z" fill="none" stroke="#111" stroke-width="2.2" stroke-linejoin="round"/><path d="M24 16.5c1.6-2.8 3.6-4.8 6.2-6.4" fill="none" stroke="#111" stroke-width="2" stroke-linecap="round"/>',
  hormone:'<g fill="none" stroke="#111" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M39.5 17.5A17.5 17.5 0 1 0 41.5 26"/><path d="M41 9.5v8.5h-8.5"/><circle cx="24" cy="20.5" r="6.5"/><path d="M24 27v12M19.5 34h9"/></g><circle cx="24" cy="20.5" r="3.2" fill="#111"/>'
};
const icon = n => SHOPICONS[n] ? `<img src="${SHOPICONS[n]}" alt="" width="44" height="44">`
  : NEUICONS[n] ? `<svg viewBox="0 0 48 48" class="neu" aria-hidden="true">${NEUICONS[n]}</svg>` : svg(n, 'linie');
const CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
const PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
const GELD = new Intl.NumberFormat(R.dataset.locale || 'de-DE', {style: 'currency', currency: R.dataset.waehrung || 'EUR'});
const euro = n => GELD.format(n);
const esc = s => String(s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));

R.querySelectorAll('[data-icon]').forEach(e => e.innerHTML = svg(e.dataset.icon));
document.getElementById('dauer').textContent = t('start_dauer', {n: CFG.fragen.length, zeit: t(CFG.fragen.length > 6 ? 'start_dauer_lang' : 'start_dauer_kurz')});

/* Tracking-Stub: im Theme wird daraus Shopify.analytics.publish + Klaviyo */
/* Traks (analytics.melinava.tech, Site melinava.de): window.traks(name, flache Props, Wert).
   Feuert nur auf melinava.de, im Prototyp nur Konsole. Props flach und niedrig-kardinal halten. */
function track(name, props={}, wert){
  console.log('[traks]', name, props, wert === undefined ? '' : wert);
  if (LIVE && typeof window.traks === 'function') window.traks(name, Object.assign({}, props, {sprache: R.dataset.locale}), wert);
}

const antworten = {};
let schritt = 0;
const geschlecht = () => ({geschlecht_frau:'frau', geschlecht_mann:'mann'})[antworten.geschlecht] || 'offen';
const sichtbar = o => !o.nur || geschlecht() === 'offen' || o.nur === geschlecht();

/* Ziel nur anbieten, wenn im Shop dieses Marktes mindestens 2 passende Produkte verfügbar sind
   (z. B. Schlaf in Dänemark: Melatonin, GABA, L-Theanin, Ashwagandha und Baldrian gibt es dort nicht) */
const zielMoeglich = id => {
  const z = CFG.ziele[id]; if (!z) return false;
  const da = h => KATALOG[h] && KATALOG[h].verfuegbar !== false;
  const gruppenDa = new Set(z.unterziele.flatMap(u => u.set).concat(z.reserve).map(x => x.p).filter(da).map(gruppe));
  return gruppenDa.size >= 2;
};
function optionenVon(f){
  if (f.dynamisch) return (CFG.ziele[antworten.ziel] || {unterziele:[]}).unterziele.filter(sichtbar);
  if (f.id === 'ziel') return f.optionen.filter(sichtbar).filter(o => zielMoeglich(o.id));
  return f.optionen.filter(sichtbar);
}

function nachOben(){ const y = R.getBoundingClientRect().top + window.scrollY - 90; if (window.scrollY > y) window.scrollTo({top: Math.max(0, y), behavior: 'smooth'}); }

/* Warenkorb: /cart/add.js, danach den Warenkorb-Drawer des Themes aktualisieren und öffnen */
async function inDenWarenkorb(set, modus, fallbackUrl){
  const items = set.map(x => {
    const it = {id: KATALOG[x.p].variant, quantity: 1, properties: {_produktfinder: CFG.quizId}};
    if (modus === 'regelmaessig' && KATALOG[x.p].plan_monat) it.selling_plan = KATALOG[x.p].plan_monat;
    return it;
  });
  const btn = document.getElementById('set-cta');
  btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '.6';
  try {
    const res = await fetch(ROOT + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: JSON.stringify({items})});
    if (!res.ok) throw new Error('cart/add ' + res.status);
    await fetch(ROOT + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes: {produktfinder_variante: VARIANTE}})});
    const html = await (await fetch(location.pathname + '?section_id=helper-cart')).text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const form = document.getElementById('AjaxCartForm'), neuForm = doc.getElementById('AjaxCartForm');
    if (form && neuForm) { form.innerHTML = neuForm.innerHTML; if (form.ajaxifyCartItems) form.ajaxifyCartItems(); }
    const sub = document.getElementById('AjaxCartSubtotal'), neuSub = doc.getElementById('AjaxCartSubtotal');
    if (sub && neuSub) sub.innerHTML = neuSub.innerHTML;
    const anzahl = doc.querySelector('[data-cart-count]');
    if (anzahl) document.querySelectorAll('[data-header-cart-count]').forEach(e => e.textContent = anzahl.textContent);
    const drawer = document.getElementById('site-cart-sidebar');
    if (drawer && typeof drawer.show === 'function') { drawer.classList.remove('cart-is-empty'); drawer.show(); }
    else location.href = ROOT + 'cart';
  } catch (e) {
    console.error('[produktfinder]', e);
    location.href = fallbackUrl;
  } finally {
    btn.removeAttribute('aria-busy'); btn.style.opacity = '';
  }
}

/* Warenkorb-Attribut für die Bestellzuordnung (einmal pro Seitenaufruf, auch bei leerem Warenkorb) */
let markiert = false;
function warenkorbMarkieren(){
  if (markiert) return; markiert = true;
  fetch(ROOT + 'cart/update.js', {method: 'POST', keepalive: true, headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes: {produktfinder_variante: VARIANTE}})}).catch(() => { markiert = false; });
}

function zeige(id){ R.querySelectorAll('.screen').forEach(s => s.classList.toggle('aktiv', s.id === id)); nachOben(); }

function frageRendern(){
  const f = CFG.fragen[schritt];
  const n = CFG.fragen.length;
  const opts = optionenVon(f);
  /* Antwort passt nicht mehr (z. B. Ziel geändert): zurücksetzen */
  if (!f.mehrfach && antworten[f.id] && !opts.some(o => o.id === antworten[f.id])) delete antworten[f.id];
  if (f.mehrfach && antworten[f.id]) antworten[f.id] = antworten[f.id].filter(id => opts.some(o => o.id === id));
  document.getElementById('f-nr').textContent = t('frage_nr', {nr: schritt+1, n});
  document.getElementById('f-proz').textContent = Math.round((schritt+1)/n*100) + ' %';
  document.getElementById('f-balken').style.width = ((schritt+1)/n*100) + '%';
  document.getElementById('f-eyebrow').textContent = f.eyebrow;
  document.getElementById('f-titel').textContent = f.titel;
  document.getElementById('f-warum').textContent = f.warum;
  document.getElementById('f-notiz').classList.remove('zeigen');
  const gewaehlt = id => f.mehrfach ? (antworten[f.id]||[]).includes(id) : antworten[f.id] === id;
  const box = document.getElementById('f-optionen');
  box.classList.toggle('zwei', opts.length > 5);
  box.setAttribute('role', f.mehrfach ? 'group' : 'radiogroup');
  box.innerHTML = opts.map(o => `
    <button class="opt${f.mehrfach?' mehr':''}${gewaehlt(o.id)?' gewaehlt':''}" role="${f.mehrfach?'checkbox':'radio'}" aria-checked="${gewaehlt(o.id)}" data-id="${o.id}">
      <span class="ico">${icon(o.icon)}</span>
      <span class="txt"><span class="lab">${esc(o.label)}</span>${o.sub?`<span class="sub">${esc(o.sub)}</span>`:''}</span>
      <span class="radio"></span>
    </button>`).join('');
  box.querySelectorAll('.opt').forEach(b => b.addEventListener('click', () => f.mehrfach ? umschalten(f, b.dataset.id) : waehle(f, b.dataset.id)));
  const mehrBtn = document.getElementById('f-mehr');
  mehrBtn.hidden = !f.mehrfach;
  mehrBtn.disabled = !(antworten[f.id]||[]).length;
  mehrBtn.textContent = t(schritt === n - 1 ? 'zur_empfehlung' : 'weiter');
}

function umschalten(f, id){
  const opt = optionenVon(f).find(o => o.id === id);
  let liste = antworten[f.id] || [];
  if (liste.includes(id)) liste = liste.filter(x => x !== id);
  else if (opt.exklusiv) liste = [id];
  else liste = liste.filter(x => !optionenVon(f).find(o => o.id === x).exklusiv).concat(id);
  antworten[f.id] = liste;
  R.querySelectorAll('#f-optionen .opt').forEach(b => { const an = liste.includes(b.dataset.id); b.classList.toggle('gewaehlt', an); b.setAttribute('aria-checked', an); });
  document.getElementById('f-mehr').disabled = !liste.length;
}

let weiterTimer = null;
function waehle(f, id){
  antworten[f.id] = id;
  R.querySelectorAll('#f-optionen .opt').forEach(b => { const an = b.dataset.id === id; b.classList.toggle('gewaehlt', an); b.setAttribute('aria-checked', an); });
  track('pf_frage', {frage: f.id, nr: schritt+1});
  clearTimeout(weiterTimer);
  if (f.id === 'ziel') {
    document.getElementById('f-notiz-text').textContent = CFG.ziele[id].hinweis;
    const notiz = document.getElementById('f-notiz');
    notiz.classList.remove('zeigen'); void notiz.offsetWidth; notiz.classList.add('zeigen');
    notiz.scrollIntoView({behavior:'smooth', block:'nearest'});
    weiterTimer = setTimeout(weiter, 3200);
  } else {
    weiterTimer = setTimeout(weiter, 280);
  }
}

/* Ladebildschirm: 3 Schritte nacheinander, je Ladekreis, dann Haken. Gesamt etwa 5,5 Sekunden. */
function ladeAnimation(fertig){
  const z = CFG.ziele[antworten.ziel] || {unterziele: []};
  const ziel = (CFG.fragen[0].optionen.find(o => o.id === antworten.ziel) || {}).label || '';
  const u = z.unterziele.find(x => x.id === antworten.unterziel);
  const nimmt = (antworten.bereits || []).filter(id => !/_nichts$/.test(id)).length;
  const schritte = [
    [t('laden1_titel'), u ? t('laden1_sub_schwerpunkt', {ziel, schwerpunkt: u.label}) : t('laden1_sub', {ziel})],
    [t('laden2_titel'), t(nimmt ? 'laden2_sub_bereits' : 'laden2_sub')],
    [t('laden3_titel'), t('laden3_sub')]
  ];
  const liste = document.getElementById('ladeschritte');
  liste.innerHTML = schritte.map(([titel, sub]) => `<li class="ladeschritt"><span class="status"></span><span><b>${esc(titel)}</b><small>${esc(sub)}</small></span></li>`).join('');
  const balken = document.getElementById('ladebalken');
  balken.style.transition = 'none'; balken.style.width = '0';
  zeige('s-laden');
  requestAnimationFrame(() => { balken.style.transition = 'width 5.4s linear'; balken.style.width = '100%'; });
  const el = [...liste.children];
  const takt = [[0, 1700], [1800, 3500], [3600, 5200]];   /* [erscheint, Haken] in ms */
  takt.forEach(([an, aus], i) => {
    setTimeout(() => el[i].classList.add('da'), an + 60);
    setTimeout(() => { el[i].classList.add('fertig'); el[i].querySelector('.status').innerHTML = CHECK; }, aus);
  });
  setTimeout(fertig, 5700);
}

function weiter(){
  clearTimeout(weiterTimer);
  const f = CFG.fragen[schritt];
  if (f.mehrfach) track('pf_frage', {frage: f.id, nr: schritt+1});
  if (schritt < CFG.fragen.length - 1) {
    schritt++;
    const naechste = CFG.fragen[schritt];
    const opts = optionenVon(naechste);
    /* nur eine sichtbare Option: automatisch wählen und überspringen */
    if (!naechste.mehrfach && opts.length === 1) { antworten[naechste.id] = opts[0].id; return weiter(); }
    frageRendern(); nachOben();
  }
  else { ladeAnimation(() => ergebnisRendern()); }
}

document.getElementById('start').addEventListener('click', () => { schritt = 0; frageRendern(); zeige('s-frage'); track('pf_start', {quelle: 'start'}); });

/* Direktlinks: ?ziel=haut startet mit gewähltem Ziel bei Frage 2, ?start=1 bei Frage 1 */
laufNachLaden(function direktlink(){
  const par = new URLSearchParams(location.search);
  const q = par.get('ziel');
  let id = q && (CFG.ziele[q] ? q : CFG.ziele['ziel_' + q] ? 'ziel_' + q : null);
  if (id && !zielMoeglich(id)) id = null;   /* Ziel in diesem Markt nicht möglich: normal bei Frage 1 bzw. Start */
  /* /pages/produktfinder?start=1 überspringt die Startseite und beginnt bei Frage 1 */
  if (!id && par.get('start') === '1') { schritt = 0; frageRendern(); zeige('s-frage'); track('pf_start', {quelle: 'link'}); return; }
  if (!id) return;
  antworten.ziel = id; schritt = 1; frageRendern(); zeige('s-frage');
  track('pf_start', {quelle: 'link', ziel: id.replace('ziel_', '')});
});

/* Letzte Empfehlung aus dem Browser (30 Tage), ohne Antworten der Sicherheitsfrage */
function ladeLokal(){
  try {
    const g = JSON.parse(localStorage.getItem('mv_produktfinder') || 'null');
    if (!g || !g.ergebnis || Date.now() - g.gespeichert > 30*864e5 || g.quiz !== CFG.quizId) return null;
    const e = g.ergebnis;
    if (!CFG.ziele[e.zielId] || ![...e.set, ...(e.extra ? [e.extra] : [])].every(x => KATALOG[x.p])) return null;
    return g;
  } catch (e) { return null; }
}
laufNachLaden(function letzteZeigen(){
  const g = ladeLokal(); if (!g) return;
  /* Aufruf über die Pille "Ihre Empfehlung" auf anderen Shopseiten: direkt das Ergebnis zeigen */
  if (new URLSearchParams(location.search).get('ansicht') === 'letzte') {
    Object.assign(antworten, g.antworten);
    ergebnisRendern(g.ergebnis);
    track('pf_letzte', {ziel: g.ergebnis.zielId.replace('ziel_', ''), quelle: 'pille'});
    return;
  }
  const datum = new Date(g.gespeichert).toLocaleDateString(T.locale, {day:'numeric', month:'numeric'});
  document.getElementById('letzte-text').innerHTML = `<span class="lief">${esc(t('letzte_text', {datum}))}</span><br><b>${esc(g.ergebnis.plan)}</b>`;
  document.getElementById('letzte-box').style.display = 'block';
  document.getElementById('letzte').addEventListener('click', () => {
    for (const k in antworten) delete antworten[k];
    Object.assign(antworten, g.antworten);
    ergebnisRendern(g.ergebnis);
    track('pf_letzte', {ziel: g.ergebnis.zielId.replace('ziel_', '')});
  });
});
document.getElementById('f-weiter').addEventListener('click', weiter);
document.getElementById('f-mehr').addEventListener('click', weiter);
document.getElementById('zurueck').addEventListener('click', () => {
  clearTimeout(weiterTimer);
  if (schritt === 0) return zeige('s-start');
  schritt--;
  /* übersprungene Frage beim Zurückgehen ebenfalls überspringen */
  while (schritt > 0 && !CFG.fragen[schritt].mehrfach && optionenVon(CFG.fragen[schritt]).length === 1) schritt--;
  frageRendern();
});

/* ---------- Empfehlung ---------- */
/* Formpartner (Tropfen/Kapseln) gelten als derselbe Wirkstoff */
function gruppe(h){
  const partner = Object.values(CFG.formpaare[h]||{}).map(v => Array.isArray(v) ? v[0] : v);
  return [h, ...partner].sort()[0];
}

function empfehlung(){
  const zielId = antworten.ziel, z = CFG.ziele[zielId];
  const sichtbareU = z.unterziele.filter(sichtbar);
  const u = sichtbareU.find(x => x.id === antworten.unterziel) || sichtbareU[0];
  const mitFisch = antworten.ernaehrung === 'ernaehrung_gemischt';
  const pref = {form_kapseln:'kapseln', form_tropfen:'tropfen'}[antworten.form];

  const gesperrt = new Map();  /* handle -> grund */
  (antworten.bereits||[]).forEach(id => (CFG.bereits[id]||[]).forEach(h => gesperrt.set(h, 'bereits')));
  (antworten.sicherheit||[]).forEach(id => ((CFG.sicherheit[id]||{}).ausschluss||[]).forEach(h => { if (!gesperrt.has(h)) gesperrt.set(h, 'sicherheit'); }));

  const anpassen = x => {
    x = {...x};
    if (!mitFisch && CFG.ohneFischErsatz[x.p]) x.p = CFG.ohneFischErsatz[x.p];
    if (pref && !x.formFest) {
      const paar = (CFG.formpaare[x.p]||{})[pref];
      if (paar) { if (Array.isArray(paar)) { x.p = paar[0]; x.warum = paar[1]; x.claim = !!paar[2]; } else x.p = paar; }
    }
    return x;
  };
  const entfernt = [];
  const erlaubt = x => {
    if (!KATALOG[x.p] || KATALOG[x.p].verfuegbar === false) return false;   /* fehlt im Shop oder ausverkauft */
    if (!mitFisch && CFG.mitFisch.includes(x.p)) return false;
    /* gesperrt, wenn das Produkt selbst oder seine andere Form gesperrt ist */
    const g = gruppe(x.p);
    for (const [h, grund] of gesperrt) if (gruppe(h) === g) { entfernt.push({p: x.p, grund}); return false; }
    return true;
  };
  const gruppen = new Set(), set = [];
  const nimm = x => { const g = gruppe(x.p); if (gruppen.has(g)) return; gruppen.add(g); set.push(x); };
  u.set.map(anpassen).forEach(x => { if (erlaubt(x)) nimm(x); });
  for (const x of z.reserve.map(anpassen)) { if (set.length >= 3) break; if (!gruppen.has(gruppe(x.p)) && erlaubt(x)) nimm(x); }

  let extra = (CFG.lebensphase[antworten.alter]||[]).map(anpassen).find(e => !gruppen.has(gruppe(e.p)) && erlaubt(e));
  const bereitsGruppen = new Map();
  entfernt.filter(e => e.grund === 'bereits').forEach(e => { if (!bereitsGruppen.has(gruppe(e.p))) bereitsGruppen.set(gruppe(e.p), KATALOG[e.p].titel); });
  const bereitsWeg = [...bereitsGruppen.values()];
  /* Hinweistext je Sicherheitsantwort: mit Ausschluss nur, wenn wirklich etwas weggefallen ist */
  const sicherWeg = new Set(entfernt.filter(e => e.grund === 'sicherheit').map(e => gruppe(e.p)));
  const sicherTexte = (antworten.sicherheit||[]).map(id => {
    const s = CFG.sicherheit[id]; if (!s) return '';
    const traf = (s.ausschluss||[]).some(h => sicherWeg.has(gruppe(h)));
    return traf ? s.text : (s.textOhneAusschluss || s.text);
  }).filter((x, i, a) => x && a.indexOf(x) === i);
  const sicherGruppen = new Map();
  entfernt.filter(e => e.grund === 'sicherheit').forEach(e => { if (!sicherGruppen.has(gruppe(e.p))) sicherGruppen.set(gruppe(e.p), KATALOG[e.p].titel); });
  const sicherWegNamen = [...sicherGruppen.values()];
  /* Claim im Kopf nur zeigen, wenn ein Produkt im Set ihn trägt */
  const hinweisRoh = u.hinweis || z.hinweis;
  const traeger = z.unterziele.flatMap(x => x.set).concat(z.reserve).filter(x => x.warum === hinweisRoh).map(x => gruppe(x.p));
  let hinweis = !set.length ? '' : (!traeger.length || set.some(x => traeger.includes(gruppe(x.p)) && x.warum === hinweisRoh)) ? hinweisRoh : '';
  if (!hinweis && set.length) hinweis = (set.find(x => x.claim) || {}).warum || '';
  const plan = set.length ? (u.plan || z.plan) : t('plan_standard');
  return {zielId, z, u, set, hinweis, plan, extra, bereitsWeg, sicherTexte, sicherWegNamen};
}

/* Sterne nur in Märkten, in denen der Shop Judge.me-Sterne zeigt (T.sterne_zeigen) */
const sterne = (k, kurz) => T.sterne_zeigen !== false && k.bewertungen ? `<span class="bew"><span class="st" aria-hidden="true">★</span> ${zahl1(k.sterne)} <span class="sr">${esc(t('sterne_sr'))}</span>(${k.bewertungen}${kurz ? '' : ' ' + esc(t(k.bewertungen === 1 ? 'bewertung_1' : 'bewertung_n'))})</span>` : '';

/* Produktseite im neuen Tab. Ist der Rabattcode angelegt, läuft der Link über /discount/CODE, damit der Code für den Einkauf gespeichert ist. */
/* Set-Karte im Ergebnis (Bilder, Lieferwahl, Preis) ein- oder ausblenden: ergebnisSetKarte in quiz-config.json */
const SETKARTE = CFG.ergebnisSetKarte !== false;
/* Produkt-URL: im Theme die übersetzte URL aus Liquid (Handles sind je Sprache übersetzt), im Prototyp /products/<handle> */
const pfad = h => (KATALOG[h] && KATALOG[h].url) || `/products/${h}`;
const pdpUrl = h => (CFG.rabatt.aktiv && CFG.rabatt.codeAngelegt) ? `${SHOP}/discount/${CFG.rabatt.code}?redirect=${pfad(h)}` : (KATALOG[h] && KATALOG[h].url) ? KATALOG[h].url : `${SHOP}/products/${h}`;

/* A/B-Test Hauptbutton: 'warenkorb' oder 'produktseiten' */
const VARIANTE = (function(){
  const t = CFG.ergebnisTest || {};
  const url = new URLSearchParams(location.search).get('variante');
  if (url === 'warenkorb' || url === 'produktseiten') return url;
  if (!t.aktiv) return t.standard || 'warenkorb';
  try {
    let v = localStorage.getItem('mv_pf_variante');
    if (v !== 'warenkorb' && v !== 'produktseiten') { v = Math.random() * 100 < (t.anteilProduktseiten || 0) ? 'produktseiten' : 'warenkorb'; localStorage.setItem('mv_pf_variante', v); }
    return v;
  } catch (e) { return t.standard || 'warenkorb'; }
})();

function produktZeile(x, extraTitel){
  const k = KATALOG[x.p];
  const chips = [k.einnahme, x.zusatz].filter(Boolean).map(c => `<span class="chip">${esc(c)}</span>`).join('');
  const url = pdpUrl(x.p);
  return `<div class="produkt${extraTitel?' extra':''}">
    <a class="bildlink" href="${url}" target="_blank" rel="noopener" data-pdp="bild" tabindex="-1" aria-hidden="true"><img src="${k.bild}" alt="" loading="lazy"></a>
    <div class="info">
      ${extraTitel?`<span class="mvpf-pill hell">${esc(extraTitel)}</span>`:''}
      <a class="mvpf-name" href="${url}" target="_blank" rel="noopener" data-pdp="name">${esc(k.titel)}</a>
      ${sterne(k)}
      <p class="warum">${esc(x.warum)}</p>${chips}
      <div class="unterzeile"><span class="preisbox"><span class="p">${euro(k.preis)}</span>${k.preis_lieferung ? `<span class="lief">${esc(t('regelmaessig_preis', {preis: euro(k.preis_lieferung)}))}</span>` : ''}</span>
        <a class="zumprodukt${VARIANTE === 'produktseiten' ? ' voll' : ''}" href="${url}" target="_blank" rel="noopener" data-pdp="zeile" aria-label="${esc(t('zum_produkt_aria', {titel: k.titel}))}">${esc(t('zum_produkt'))}</a></div>
    </div>
  </div>`;
}

const FUSSNOTEN = {
  'liposomales-melatonin': t('fussnote_melatonin'),
  'kreatin-monohydrat': t('fussnote_kreatin'),
  'omega-3-vegan': t('fussnote_dha') + ' ' + t('fussnote_epa_dha'),
  'omega-3': t('fussnote_epa_dha')
};

/* ---------- Klaviyo ----------
   Im Theme echte Aufrufe, im Prototyp nur Konsole.
   1) Besucher ist Klaviyo schon bekannt (Klick aus einer Klaviyo-Mail, eingeloggte Kundin):
      klaviyo.identify(profil) + klaviyo.track('Produktfinder abgeschlossen', event)
   2) Besucher gibt im Ergebnis die E-Mail ein:
      POST https://a.klaviyo.com/client/subscriptions?company_id=PUBLIC_KEY (Profil-Eigenschaften + Liste, Double Opt-in)
   3) Unbekannt und keine E-Mail: Klaviyo kann ohne Profil nichts speichern. Die Antworten bleiben 30 Tage
      im Browser (localStorage) und werden nachgereicht, sobald sich die Person zu erkennen gibt
      (Newsletter-Popup, Login, Kasse).
   Antworten der Sicherheitsfrage gehen nie an Klaviyo. */
function klaviyoDaten(zielId, u, set, extra){
  const profil = {};
  CFG.fragen.filter(f => !f.nichtSpeichern).forEach(f => [].concat(antworten[f.id]||[]).filter(id => !/_nichts$/.test(id)).forEach(id => profil[id] = true));
  const heute = new Date().toISOString().slice(0, 10);
  Object.assign(profil, {
    pf_ziel: zielId.replace('ziel_', ''),
    pf_schwerpunkt: u.id,
    pf_empfehlung: set.map(x => KATALOG[x.p].titel).join(', '),
    pf_datum: heute,
    pf_quiz: CFG.quizId,
    pf_sprache: String(T.locale || '').slice(0, 2)
  });
  const event = {
    ziel: zielId, schwerpunkt: u.id,
    produkte: set.map(x => ({titel: KATALOG[x.p].titel, handle: x.p, url: new URL(pdpUrl(x.p), location.origin).href, bild: KATALOG[x.p].bild, preis: KATALOG[x.p].preis})),
    extra: extra ? extra.p : null,
    set_preis: Math.round(set.reduce((s, x) => s + KATALOG[x.p].preis, 0) * 100) / 100,
    set_link: `${SHOP}/cart/${set.map(x => KATALOG[x.p].variant + ':1').join(',')}`,
    sprache: String(T.locale || '').slice(0, 2),
    unique_id: CFG.quizId + '-' + Date.now()
  };
  return {profil, event};
}
function speichereLokal(kv, ergebnis){
  /* Antworten ohne Sicherheitsfrage */
  const ohneSicherheit = Object.fromEntries(Object.entries(antworten).filter(([k]) => !(CFG.fragen.find(f => f.id === k) || {}).nichtSpeichern));
  try { localStorage.setItem('mv_produktfinder', JSON.stringify({...kv, ergebnis, antworten: ohneSicherheit, quiz: CFG.quizId, gespeichert: Date.now()})); } catch (e) {}
}
/* Kein E-Mail-Feld (Entscheidung 2026-10-22). Nur wenn Klaviyo die Person schon kennt (Klick aus einer Mail,
   eingeloggt), gehen Antworten ins Profil plus Event "Produktfinder abgeschlossen". Sonst reicht die Pille
   (snippets/mv-produktfinder-pille.liquid) das nach, sobald Klaviyo die Person erkennt. Nur im Live-Theme. */
function klaviyoSenden(kv){
  const k = window.klaviyo;
  const aktiv = typeof LIVE !== 'undefined' && LIVE && k && typeof k.isIdentified === 'function';
  if (!aktiv) { console.log('[klaviyo] würde senden, falls Besucher bekannt:', kv.profil, 'Produktfinder abgeschlossen', kv.event); return; }
  Promise.resolve(k.isIdentified()).then(bekannt => {
    if (!bekannt) return;
    k.identify(kv.profil);
    k.track('Produktfinder abgeschlossen', kv.event);
    try { const g = JSON.parse(localStorage.getItem('mv_produktfinder')); g.klaviyoGesendet = Date.now(); localStorage.setItem('mv_produktfinder', JSON.stringify(g)); } catch (e) {}
  }).catch(() => {});
}

function ergebnisRendern(gespeichert){
  const e = gespeichert
    ? {...gespeichert, z: CFG.ziele[gespeichert.zielId], u: CFG.ziele[gespeichert.zielId].unterziele.find(x => x.id === gespeichert.uId) || CFG.ziele[gespeichert.zielId].unterziele[0], sicherTexte: [], sicherWegNamen: gespeichert.sicherWegNamen || []}
    : empfehlung();
  const {zielId, z, u, set, hinweis, plan, extra, bereitsWeg, sicherTexte, sicherWegNamen} = e;
  const zielKurz = zielId.replace('ziel_', '');
  const label = id => { for (const f of CFG.fragen) { const o = (f.dynamisch ? z.unterziele : f.optionen).find(o => o.id === id); if (o) return o.kurz || o.label; } return ''; };
  const chipIds = CFG.fragen.filter(f => !f.nichtSpeichern && !f.mehrfach).flatMap(f => [].concat(antworten[f.id]||[])).filter(id => !/_nichts$/.test(id));
  const summe = set.reduce((s, x) => s + KATALOG[x.p].preis, 0);
  const anzahl = set.length;
  const r = CFG.rabatt; const rabattAn = r.aktiv && anzahl >= 2;
  const neu = rabattAn ? summe * (1 - r.prozent/100) : summe;
  const zahlwort = T['zahl_' + anzahl] || anzahl;
  const cartUrl = `${SHOP}/cart/${set.map(x => KATALOG[x.p].variant + ':1').join(',')}` + (rabattAn && r.codeAngelegt ? `?discount=${r.code}` : '');
  /* Regelmäßige Lieferung (Kaching Subscriptions = Shopify Selling Plans, Plan "Jeden Monat") */
  const lieferbar = anzahl > 0 && set.every(x => KATALOG[x.p].plan_monat);
  const summeLief = set.reduce((s, x) => s + (KATALOG[x.p].preis_lieferung || KATALOG[x.p].preis), 0);
  const liefProzent = lieferbar ? Math.round((1 - summeLief / summe) * 100) : 0;
  /* Warum diese Empfehlung? */
  const zielLabel = (CFG.fragen[0].optionen.find(o => o.id === zielId) || {}).label || '';
  const gruende = [];
  if (anzahl) gruende.push(t('grund_ziel', {ziel: zielLabel, schwerpunkt: u.label, produkt: KATALOG[set[0].p].titel}));
  if (antworten.ernaehrung && antworten.ernaehrung !== 'ernaehrung_gemischt') gruende.push(t(antworten.ernaehrung === 'ernaehrung_vegan' ? 'grund_vegan' : 'grund_vegetarisch'));
  if (antworten.form === 'form_kapseln' || antworten.form === 'form_tropfen') gruende.push(t(antworten.form === 'form_kapseln' ? 'grund_kapseln' : 'grund_tropfen'));
  if (bereitsWeg.length) gruende.push(t('grund_bereits', {liste: bereitsWeg.join(', ')}));
  if (sicherWegNamen.length) gruende.push(sicherWegNamen.length === 1 ? t('grund_sicher_1') : t('grund_sicher_n', {n: sicherWegNamen.length}));
  if (extra) gruende.push(t(antworten.alter === 'phase_50plus' ? 'grund_50plus' : 'grund_40', {produkt: KATALOG[extra.p].titel}));
  const gruppen = ['morgens','abends'].map(zeit => {
    const teil = set.filter(x => x.zeit === zeit);
    if (!teil.length) return '';
    return `<div class="gruppe"><h3>${svg(zeit==='morgens'?'sonne':'mond')}${esc(t(zeit))}</h3>${teil.map(x => produktZeile(x)).join('')}</div>`;
  }).join('');
  const fn = [...set, ...(extra?[extra]:[])].map(x => FUSSNOTEN[x.p]).filter(Boolean);

  document.getElementById('s-ergebnis').innerHTML = `
    <div class="planbox">
      <p class="eyebrow punkt">${esc(t('plan_eyebrow'))}</p>
      <h1>${esc(plan)}.</h1>
      <p class="lead">${esc(t('plan_lead'))} ${esc(hinweis)}</p>
      <div class="antwortchips">${chipIds.map(id => `<span>${esc(label(id))}</span>`).join('')}<button class="link" id="aendern">${esc(t('aendern'))}</button></div>
      ${gruende.length ? `<details class="warumbox"><summary>${esc(t('warum_titel'))}</summary><ul>${gruende.map(g => `<li>${esc(g)}</li>`).join('')}</ul></details>` : ''}
    </div>
    ${sicherTexte.length ? `<div class="notizbox sicher">${sicherTexte.map(esc).join(' ')}${sicherWegNamen.length ? `<br><br>${esc(t('sicher_weg', {liste: sicherWegNamen.join(', ')}))}` : ''}</div>` : ''}
    ${bereitsWeg.length ? `<div class="notizbox bereits">${esc(t('bereits_weg', {liste: bereitsWeg.join(', ')}))}</div>` : ''}

    ${anzahl === 0 ? `
    <div class="block">
      <h2>${esc(t('beratung_titel'))}</h2>
      <p class="lead">${esc(t('beratung_text'))}</p>
    </div>` : `
    ${SETKARTE ? `
    <div class="block">
      <h2>${esc(t(anzahl > 1 ? 'set_titel_n' : 'set_titel_1'))}</h2>
      <div class="setkarte">
        <div class="setbilder">${set.map(x => `<figure><a href="${pdpUrl(x.p)}" target="_blank" rel="noopener" data-pdp="setbild"><img src="${KATALOG[x.p].bild}" alt=""><figcaption>${esc(KATALOG[x.p].titel)}</figcaption></a>${sterne(KATALOG[x.p], true)}</figure>`).join('')}</div>
        <div class="setinhalt">
          <span class="mvpf-pill">${esc(t('pill_empfehlung'))}</span>
          ${lieferbar && VARIANTE === 'warenkorb' ? `<div class="lieferwahl" role="radiogroup" aria-label="${esc(t('lieferart'))}">
            <button class="liefopt gewaehlt" role="radio" aria-checked="true" data-modus="einmalig"><span class="radio"></span><span class="txt"><b>${esc(t('einmalig'))}</b></span></button>
            <button class="liefopt" role="radio" aria-checked="false" data-modus="regelmaessig"><span class="radio"></span><span class="txt"><b>${esc(t('regelmaessig'))}</b><small>${esc(t('regelmaessig_sub'))}</small><span class="mvpf-pill">${esc(t('sparen', {p: liefProzent}))}</span></span></button>
          </div>` : ''}
          <div class="preiszeile" id="set-preis"></div>
          ${VARIANTE === 'produktseiten'
            ? `<a class="btn" id="set-cta" href="#routine">${esc(t(anzahl > 1 ? 'produkte_ansehen' : 'produkt_ansehen'))}</a>`
            : `<a class="btn" id="set-cta" href="${cartUrl}">${esc(anzahl > 1 ? t('alle_warenkorb', {n: anzahl}) : t('in_warenkorb'))}</a>`}
          
          <ul class="checks">
            ${rabattAn ? `<li>${CHECK}${esc(t('rabatt_check', {p: r.prozent}))}</li>` : ''}
            ${anzahl > 1 ? `<li>${CHECK}${esc(t('abgestimmt', {zahl: zahlwort}))}</li>` : ''}
            ${VARIANTE === 'produktseiten' && lieferbar ? `<li>${CHECK}${esc(t('check_lieferwahl'))}</li>` : ''}
            <li>${CHECK}${esc(t('garantie'))}</li>
          </ul>
          <p class="klein" id="set-klein">${rabattAn ? esc(t('rabatt_kasse')) : ''}</p>
        </div>
      </div>
    </div>
    ` : ''}

    <div class="block" id="routine">
      <h2>${esc(t(SETKARTE ? 'routine_titel' : 'set_titel_1'))}</h2>
      ${gruppen}
      ${!SETKARTE && VARIANTE === 'warenkorb' && anzahl > 1 ? `<div class="alleaufeinmal">
        <div class="aa-zeile"><span>${esc(t('alle_zusammen', {n: anzahl}))}</span><span class="aa-preis">${euro(summe)}</span></div>
        <a class="btn" id="set-cta" href="${cartUrl}">${esc(t('alle_warenkorb', {n: anzahl}))}</a>
        <p class="klein">${esc(t('alle_klein'))}</p>
      </div>` : ''}
      ${extra ? `<div class="gruppe"><h3>${svg('stern')}${esc(t('lebensphase_titel'))}</h3>${produktZeile(extra, extra.titel)}</div>` : ''}
    </div>`}

    <div class="vertrauen">
      <div><span class="kreis">${svg('kunden')}</span>${esc(t('vertrauen_kunden'))}</div>
      ${T.vertrauen_sterne ? `<div><span class="kreis">${svg('stern')}</span>${esc(t('vertrauen_sterne'))}</div>` : ''}
      <div><span class="kreis">${svg('schild')}</span>${esc(t('garantie'))}</div>
    </div>

    <div class="neustart"><button class="link" id="neustart">${esc(t('neustart'))}</button></div>

    <div class="fuss">
      ${fn.map(t => `<p>${esc(t)}</p>`).join('')}
      <p>${esc(t('fuss_nem'))}</p>
      <p>${esc(t('fuss_arzt'))}</p>
      <p>${esc(t('fuss_daten', {link: '%%LINK%%'})).replace('%%LINK%%', `<a href="${SHOP}/policies/privacy-policy" target="_blank" rel="noopener">${esc(t('datenschutz'))}</a>`)}</p>
    </div>`;

  zeige('s-ergebnis');
  const kv = klaviyoDaten(zielId, u, set, extra);
  if (!gespeichert) {
    track('pf_ergebnis', {ziel: zielKurz, schwerpunkt: u.id, anzahl: anzahl, variante: VARIANTE});
    speichereLokal(kv, {zielId, uId: u.id, set, hinweis, plan, extra: extra || null, bereitsWeg});
    klaviyoSenden(kv);
  }

  let modus = 'einmalig';
  const preisZeigen = () => {
    if (!anzahl || !document.getElementById('set-preis')) return;
    const basis = modus === 'regelmaessig' ? summeLief : summe;
    const preis = rabattAn ? basis * (1 - r.prozent/100) : basis;   /* Produktfinder-Rabatt nur auf die erste Lieferung */
    const vorher = summe;
    const nach = modus !== 'regelmaessig' ? '' : rabattAn
      ? `<span class="nach">${esc(t('erste_lieferung', {preis: euro(summeLief)}))}</span>`
      : `<span class="nach">${esc(t('pro_monat'))}</span>`;
    document.getElementById('set-preis').innerHTML = `<span class="preis">${euro(preis)}</span>${preis < vorher - 0.005 ? `<span class="mvpf-alt">${euro(vorher)}</span><span class="mvpf-pill hell">${esc(t('sie_sparen', {betrag: euro(vorher - preis)}))}</span>` : ''}${nach}`;
    document.getElementById('set-klein').textContent = rabattAn ? t(modus === 'regelmaessig' ? 'rabatt_erste' : 'rabatt_kasse') : '';
  };
  preisZeigen();
  R.querySelectorAll('.liefopt').forEach(b => b.addEventListener('click', () => {
    modus = b.dataset.modus;
    R.querySelectorAll('.liefopt').forEach(x => { const an = x === b; x.classList.toggle('gewaehlt', an); x.setAttribute('aria-checked', an); });
    preisZeigen();
  }));
  if (anzahl && document.getElementById('set-cta')) document.getElementById('set-cta').addEventListener('click', ev => {
    if (VARIANTE === 'produktseiten') {
      ev.preventDefault();
      track('pf_produkte_ansehen', {ziel: zielKurz, variante: VARIANTE});
      document.getElementById('routine').scrollIntoView({behavior: 'smooth'});
      return;
    }
    const basis = modus === 'regelmaessig' ? summeLief : summe;
    track('pf_warenkorb', {art: 'set', lieferung: modus, ziel: zielKurz, variante: VARIANTE}, Math.round(basis * 100) / 100);
    ev.preventDefault(); inDenWarenkorb(set, modus, cartUrl);
  });
  R.querySelectorAll('#s-ergebnis [data-pdp]').forEach(a => a.addEventListener('click', () => {
    track('pf_produktseite', {ziel: zielKurz, quelle: a.dataset.pdp, variante: VARIANTE});
    warenkorbMarkieren();
  }));
  document.getElementById('aendern').addEventListener('click', () => { schritt = 0; frageRendern(); zeige('s-frage'); });
  document.getElementById('neustart').addEventListener('click', () => { for (const k in antworten) delete antworten[k]; zeige('s-start'); });
}

START.forEach(fn => { try { fn(); } catch (e) { console.error('[produktfinder]', e); } });
})();
